<template>
    <v-text-field
        v-model="phone"
        outlined
        required
        dense
        placeholder="+994 50 765 43 21"
        :name="name"
        :label="label"
        :value="value"
        hide-details
        :rules="rules"
    >
    </v-text-field>
</template>

<script>
import VueMask from "v-mask";
import Vue from "vue";
Vue.use(VueMask);

export default {
    props: {
        "name" :{},
        "label" :{},
        "value" :{},
        "rules" : {}
    },
    data() {
        return {
            phone: this.value ? this.value : "",
            isInternational: false,
        };
    },
    computed: {
        mask() {
            let settings = window.settings;
            if(this.isInternational){
                return "+### (##) ### ## ##";
            }
            return settings.phone_mask;
        },
        phone_placeholder(){
            let settings = window.settings;
            return settings.phone_placeholder;
        }
    },
    watch: {
        phone(value) {
            this.$emit("change", value);
            if(this.phone.slice(0, 5) == '(994)' || this.phone.slice(0, 4) == '+994'){
                this.isInternational = true;
            }else{
                this.isInternational = false;
            }
        },
    },
};
</script>